function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import classes from './rectangle-input.scss';
import { Notification } from './components/notification';
export class RectangleInput extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      focused: false
    });
    _defineProperty(this, "onFocus", () => {
      var _this$props$input;
      const onFocus = (_this$props$input = this.props.input) === null || _this$props$input === void 0 ? void 0 : _this$props$input.onFocus;
      if (onFocus) {
        onFocus();
      }
      this.setState({
        focused: true
      });
    });
    _defineProperty(this, "onBlur", () => {
      var _this$props$input2;
      const onBlur = (_this$props$input2 = this.props.input) === null || _this$props$input2 === void 0 ? void 0 : _this$props$input2.onBlur;
      if (onBlur) {
        onBlur();
      }
      this.setState({
        focused: false
      });
    });
  }
  render() {
    const {
      input,
      label,
      icon,
      formType = 'text',
      placeholder,
      className,
      labelClassName,
      wrapperClassName,
      dataInput,
      disabled,
      errorClassName,
      notificationClassName,
      hideError = false,
      hideErrorWhenFocused = false,
      isErrorShownImmediately = false,
      input: {
        onChange = undefined,
        name = undefined,
        value = undefined
      } = {},
      meta: {
        touched = undefined,
        active = undefined,
        error = undefined
      } = {}
    } = this.props;
    const {
      focused
    } = this.state;
    const isTouched = touched && !active;
    const isReadyToShowError = isErrorShownImmediately ? isTouched : isTouched && !(hideErrorWhenFocused && focused);
    const showError = error && isReadyToShowError;
    return /*#__PURE__*/React.createElement("div", {
      className: wrapperClassName
    }, label && /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.label, labelClassName)
    }, label), icon, /*#__PURE__*/React.createElement("input", _extends({
      value: value
    }, input, {
      type: formType,
      onChange: onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      placeholder: placeholder,
      name: name,
      disabled: disabled,
      className: classnames(classes.input, className, {
        [classes.inputError]: showError
      }, errorClassName && {
        [errorClassName]: showError
      }),
      "data-input": dataInput
    })), !hideError && isReadyToShowError && /*#__PURE__*/React.createElement(Notification, {
      className: notificationClassName,
      message: error
    }));
  }
}